<template>
  <div class="statistics-center">
    <div
      v-for="(rateTable, rateIndex) in renderRateTableData"
      :key="rateIndex"
      class="df"
    >
      <table class="rate-table project-table" border="1">
        <tr>
          <th rowspan="2" class="project">项目</th>
        </tr>
        <tr></tr>
        <tr v-for="(item, index) in PQCProductOption" :key="index">
          <th class="process">{{ item.label }}</th>
        </tr>
      </table>

      <table
        v-for="(item, index) in rateTable"
        :key="index"
        border="1"
        class="rate-table"
      >
        <tr>
          <!-- <td rowspan="2">项目</td> -->
          <th colspan="4">{{ item.month }} 月</th>
        </tr>

        <tr>
          <th>交检</th>
          <th>合格</th>
          <th>合格率</th>
          <th>环比</th>
        </tr>

        <tr v-for="(subItem, subIndex) in item.data" :key="subIndex">
          <td>{{ subItem.submissionNum }}</td>
          <td>{{ subItem.qualifiedNum }}</td>
          <td>
            <div v-if="subItem.firstPassRate">{{ subItem.firstPassRate }}%</div>
          </td>
          <td>
            <div v-if="subItem.qoq">{{ subItem.qoq }}%</div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { defineComponent, watch, reactive, computed } from "vue";
import { PQCProductOption as productOption } from "@/views/productDaily/serve/option";
import { debounce } from "@/utils";

export default defineComponent({
  props: {
    statisticsData: Object,
  },
  setup(props, context) {
    const rateData = reactive([]);

    const PQCProductOption = productOption.filter(
      (f) => f.label !== "束腰" && f.label !== "绕光纤参考臂" && f.label !== "包装"
    );

    // 获取空数据
    const getEmptyData = () => {
      return {
        submissionNum: "",
        qualifiedNum: "",
        firstPassRate: "",
        qoq: "",
      };
    };
    // 设置月份空数据
    const setYearRateData = () => {
      rateData.length = 0;
      for (let index = 1; index <= 12; index += 1) {
        const data = { month: index, data: [] };
        PQCProductOption.forEach((item) => {
          data.data.push(getEmptyData());
        });
        rateData.push(data);
      }
    };
    // 更新表格数据
    const updateRateTable = (data, processIndex) => {
      Object.keys(data).forEach((month) => {
        // 月份汇总数据
        const index = Number(month) - 1;
        const monthData = data[month];

        monthData.firstPassRate = Number(monthData.firstPassRate * 100).toFixed(
          2
        );
        monthData.qoq = Number(monthData.qoq * 100).toFixed(2);
        rateData[index].data[processIndex] = monthData;
      });
    };
    // 设置月份数据
    const setRateData = debounce((data) => {
      setYearRateData();

      if (Object.prototype.toString.call(data) !== "[object Object]") return;
      if (Object.keys(data).length === 0) return;

      PQCProductOption.forEach((item, index) => {
        // 工序
        const process = item.value;
        // 请求回来的数据
        const processData = data[process];
        // 如果有数据
        if (processData) {
          updateRateTable(processData, index);
        }
      });
    }, 100);

    // 侧边表格宽度
    const broadsideWidth = 120;

    // 屏幕宽度
    const windowWidth = window.screen.width - 60;

    // 表格宽度
    const tablewidth = 680;

    // 一行可以放几个表格
    const rowIndex = Math.ceil((windowWidth - broadsideWidth) / tablewidth);

    const renderRateTableData = computed(() => {
      const list = [];

      const count = Math.ceil(rateData.length / rowIndex);

      for (let i = 1; i <= count; i += 1) {
        const start = (i - 1) * rowIndex;
        const end = i * rowIndex;
        list.push(rateData.slice(start, end));
      }
      return list;
    });

    watch(
      () => props.statisticsData,
      (val) => {
        setRateData(val);
      },
      {
        immediate: true,
      }
    );

    return {
      rateData,
      PQCProductOption,
      renderRateTableData,
    };
  },
});
</script>

<style lang="less" scoped>
.rate-table > tr > th {
  width: 120px;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  text-align: center;
}

.rate-table > tr > td {
  width: 120px;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  text-align: center;
}

.rate-table > tr > :nth-child(odd) {
  background: #e0e0e0;
}

// .rate-table > tr:nth-child(odd) {
//   background: #e0e0e0;
// }

.project-table > tr > :nth-child(odd) {
  background: #e0e0e0;
}

// .project-table > tr:nth-child(even) {
//   background: #e0e0e0;
// }
</style>
